import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectNew from "@/pages/ProjectNew";
import ProjectDetail from "@/pages/ProjectDetail";
import ProjectEdit from "@/pages/ProjectEdit";
import Inventory from "@/pages/Inventory";
import Sales from "@/pages/Sales";
import Customers from "@/pages/Customers";
import Finance from "@/pages/Finance";
import LandOwners from "@/pages/LandOwners";
import Documents from "@/pages/Documents";
import Materials from "@/pages/Materials";
import Reports from "@/pages/Reports";
import AIAssistant from "@/pages/AIAssistant";
import Vendors from "@/pages/Vendors";
import Purchases from "@/pages/Purchases";
import MaterialIssues from "@/pages/MaterialIssues";
import MaterialReturns from "@/pages/MaterialReturns";
import StockMovements from "@/pages/StockMovements";
import ExpenseCategoriesPage from "@/pages/ExpenseCategories";
import VendorLedger from "@/pages/VendorLedger";
import SalesWorkflow from "@/pages/SalesWorkflow";
import Partners from "@/pages/Partners";
import Loans from "@/pages/Loans";
import Users from "@/pages/Users";
import "@/App.css";

function Guarded({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Guarded><Layout /></Guarded>}>
          <Route index element={<Dashboard />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/new" element={<ProjectNew />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/projects/:id/edit" element={<ProjectEdit />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/sales-workflow" element={<SalesWorkflow />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/land-owners" element={<LandOwners />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/materials" element={<Materials />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/vendor-ledger" element={<VendorLedger />} />
          <Route path="/purchases" element={<Purchases />} />
          <Route path="/material-issues" element={<MaterialIssues />} />
          <Route path="/material-returns" element={<MaterialReturns />} />
          <Route path="/stock-movements" element={<StockMovements />} />
          <Route path="/expense-categories" element={<ExpenseCategoriesPage />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/users" element={<Users />} />
          <Route path="/ai" element={<AIAssistant />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
